var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFaceN1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 46,
    viewBox: "0 0 24 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8471 20.081L23.2751 24.669C23.2295 25.0391 23.0505 25.3798 22.7715 25.6273C22.4926 25.8747 22.1329 26.0119 21.7601 26.013H14.3281V45.199C13.5434 45.2657 12.7494 45.299 11.9461 45.299C10.1858 45.2999 8.42975 45.1254 6.70406 44.778V26.006H0.992065C0.73912 26.005 0.496878 25.9038 0.318298 25.7247C0.139719 25.5455 0.0393246 25.3029 0.0390625 25.05V19.306C0.0393246 19.053 0.139719 18.8104 0.318298 18.6313C0.496878 18.4521 0.73912 18.3511 0.992065 18.35H6.70805V9.74603C6.70556 8.49204 6.95008 7.24976 7.42766 6.09027C7.90523 4.93078 8.60651 3.87669 9.49146 2.98822C10.3764 2.09975 11.4277 1.39436 12.5853 0.91217C13.7429 0.429984 14.9841 0.180532 16.2381 0.17804H22.9081C23.161 0.179097 23.4032 0.280148 23.5818 0.45929C23.7604 0.638431 23.8608 0.881025 23.8611 1.13397V6.87604C23.8608 7.12898 23.7604 7.37146 23.5818 7.5506C23.4032 7.72974 23.161 7.83091 22.9081 7.83197H18.1451C17.6435 7.83302 17.147 7.93284 16.684 8.12579C16.221 8.31875 15.8005 8.60113 15.4466 8.9566C15.0927 9.31208 14.8123 9.73371 14.6214 10.1976C14.4305 10.6614 14.3329 11.1584 14.3341 11.66V18.3599H22.3341C22.5513 18.3605 22.7659 18.4074 22.9636 18.4974C23.1614 18.5873 23.3377 18.7184 23.4809 18.8818C23.6241 19.0451 23.7309 19.2371 23.7942 19.4449C23.8575 19.6527 23.8759 19.8715 23.8481 20.087L23.8471 20.081Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceN1);
export default __webpack_public_path__ + "static/media/face-n-1.316a4aa5830ce614e5cad4305b579306.svg";
export { ForwardRef as ReactComponent };